export default "__VITE_ASSET__CWq3b$7m__"